module.exports = __webpack_public_path__ + "media/stylesheets/images/main/logoPng-2c6487ce4a500f6211a4388c306b54f6.png";